<template>
  <div class="answer_container">
    <template001 :params="params" :detail="detail" @submited="submited" @alreadySubmited="alreadySubmited" v-if="!!detail && !isSubmittedAnswer && template=='001'"></template001>
    <template002 :params="params" :detail="detail" @submited="submited" @alreadySubmited="alreadySubmited" v-else-if="!!detail && !isSubmittedAnswer && template=='002'"></template002>
    <result :params="params" :result="result" v-else-if="!!detail && isSubmittedAnswer"></result>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import answerApi from "@/api/apis/answer.js";
import commApi from "@/api/apis/common.js";
import template001 from "./templates/template001"; // 题目列表
import template002 from "./templates/template002"; // 题目列表
import result from "./components/Result"; // 答题结果
export default {
  name: "AnswerDetail",
  data() {
    return {
      template: "001",
      params: {
        contentType: 10,
        id: null,
        type: 1, // 类型 0-学习 1-答题
      },
      detail: null, // 详情
      isSubmittedAnswer: false, // 是否提交过答题
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  components: {
    template001,
    template002,
    result,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/answer_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;
      var desc = _this.detail.summaryStatus && _this.detail.summarySth ? _this.detail.summarySth : _this.detail.introduction;
      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.detail.title, desc, _this.shareUrl, _this.detail.focusPicUrl);
        this.$emit('initWeiXinTicket');
      }).catch((err) => {

      })
    },
    /* 获取答题详情 */
    getQuestionnaireDetail() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      answerApi
        .getQuestionnaireDetail(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
            // 中宣部埋点：首页页面浏览（答题，once 防止二次拉取重复上报）
            _this.$track.trackPageViewOnce(
              _this.$track.EVENT_CODE.HOME_PG,
              _this.$track.mapArticleProps(_this.detail, {
                pageName: "答题详情页",
                pageId: "answer_detail",
                extra: { article_type: "答题" },
              })
            );
            _this.wechatShare(); // 微信二次分享
            _this.isSubmittedAnswer = res.data.isSubmittedAnswer;
            if (_this.isSubmittedAnswer) {
              _this.result = res.data.submittedValue;
            }
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 只获取答题详情 */
    getQuestionnaireDetailOnly() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      answerApi
        .getQuestionnaireDetail(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
            _this.isSubmittedAnswer = res.data.isSubmittedAnswer;
            if (_this.isSubmittedAnswer) {
              _this.result = res.data.submittedValue;
            }
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 成功提交答题问卷后改变状态 */
    submited(data) {
      this.isSubmittedAnswer = true;
      this.result = data;
    },
    /* 已经提交过 */
    alreadySubmited() {
      this.isSubmittedAnswer = true;
      this.getQuestionnaireDetailOnly();
    },
  },
  created() {
    document.title = "答题";
    let query = this.$route.query;
    if (!!this.userInfo) {
      if (Object.prototype.hasOwnProperty.call(query, "id")) {
        this.params.contentType = Number(query.contentType) || 10;
        this.params.id = Number(query.id);
        this.params.type = Number(query.type) || 1;
        this.getQuestionnaireDetail(); // 获取答题详情
        loadStat(); // 友盟统计
      } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
        this.params.contentType = Number(query.contentType) || 10;
        this.params.id = Number(query.contentId);
        this.params.type = Number(query.type) || 1;
        this.getQuestionnaireDetail(); // 获取答题详情
        loadStat(); // 友盟统计
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped lang="scss">
.answer_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background: #f6f6f6;
  overflow: hidden;
}
</style>